<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Configuration Settings"
              bc1="App"
              bc2="Channel"
              bc3="Configuration"
              path="channel"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section id="dynamic-form">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                  <div class="card-header">
                    <div class="d-flex align-items-center">
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb pl-0" >
                          <li class="breadcrumb-item">Terminal</li>
                          <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb">{{crumb}}</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <div class="card-header">
                    <h4 class="card-title">Details</h4>
                  </div>
                <div class="card-body">


                  <form class="validate-form mt-2" >
                    <div v-for="(fields, section) in formData" :key="section" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center bg-light p-2" style="border-radius: 0.5rem;">
                        <h4 class="mb-0">{{ formatSectionName(section) }}</h4>
                        <div class="ml-auto"     @click="section === 'settlementConfigurations' && openSettlementSettings()" data-toggle="collapse" :data-target="'#collapse-' + section" aria-expanded="false" :aria-controls="'collapse-' + section">
                          <span class="text-primary" style="cursor: pointer;">
                            <img width="30" height="30" :src="`${publicPath}app-assets/images/icons/settings-gear.svg`" />
                          </span>
                        </div>
                      </div>

                      <div class="row mb-1">
                        <div class="col-12">
                          <div :id="'collapse-' + section" class="collapse m-1" :aria-labelledby="'heading-' + section">
                            <div class="card-body badge-glow border-secondary" style="border-radius: .8rem">
                              <div class="row">
                                <div class="col-12 mb-1">
                                  <button
                                      v-if="section === 'terminalConfigurationParameters' || section === 'settlementConfigurations'"
                                      type="button"
                                      class="btn btn-outline-warning btn-sm mr-1"
                                      @click="clearAll(section)"
                                      :disabled="loading"
                                  >
                                    Clear All Configurations
                                  </button>
                                  <button
                                      v-if="section === 'terminalConfigurationParameters'"
                                      type="button"
                                      class="btn btn-outline-warning btn-sm"
                                      @click="showClearDefaultConfirmationModal = true"
                                      :disabled="loading"
                                  >
                                    Clear Default Configurations Only
                                  </button>
                                </div>
                              </div>
                              <div class="row">
                                <!-- IBAN FIELD (SPECIAL CASE) -->
                                <div v-if="section === 'settlementConfigurations' && ibanField" class="col-8 mb-2 mt-2">
                                  <div class="form-group">
                                    <label>
                                      IBAN
                                      <!-- BADGES -->
                                      <span>
                                        <span
                                            v-if="ibanStatus == 1 || ibanStatus == 2 || ibanVerified"
                                            class="badge badge-success"
                                        >
                                          Verified
                                        </span>
                                        <span
                                            v-if="ibanStatus != 1 && (ibanStatus == 2 || ibanVerified)"
                                            class="badge badge-danger"
                                            style="margin-left: 0.2rem"
                                        >
                                          Not Saved
                                        </span>
                                        <span
                                            v-if="ibanStatus == 1"
                                            class="badge badge-info"
                                            style="margin-left: 0.2rem"
                                        >
                                          Saved
                                        </span>
                                      </span>
                                    </label>

                                    <div class="d-flex">
                                      <input
                                          type="text"
                                          class="form-control mr-1"
                                          v-model="ibanField.value"
                                          placeholder="IBAN"
                                          @input="onIbanInput"
                                          @keydown="onIbanKeydown"
                                      />

                                      <button
                                          v-if="!ibanVerified && ibanField.value !== ''"
                                          type="button"
                                          class="btn btn-outline-success btn-sm badge mr-1"
                                          @click="openIbanVerifyModal"
                                      >
                                        Verify
                                      </button>
                                      <button
                                          type="button"
                                          v-if="ibanDetailsResponse"
                                          class="btn btn-outline-dark btn-sm badge"
                                          @click="showIbanDetailsModal = true"
                                      >
                                        Show Details
                                      </button>

                                    </div>
                                  </div>
                                </div>
                                <div v-for="(field, index) in fields" :key="index" class="col-md-6">
                                  <div class="form-group">
                                    <label v-if="field.type !== 'checkbox' && field.name !== 'iban' " :for="field.name">{{ field.title }}</label>
                                    <!-- Text Input -->
                                    <input
                                        v-if="(field.type === 'text' || field.type === 'number') && field.name !== 'iban'"
                                        :type="field.type"
                                        class="form-control"
                                        :id="field.name"
                                        v-model="field.value"
                                        :placeholder="field.title"
                                    />

                                    <select
                                        v-if="field.type === 'dropDown'"
                                        class="form-control"
                                        :id="field.name"
                                        v-model="field.value"
                                        :name="field.name"
                                    >
                                      <option :value="null" selected>Select {{ field.title }}</option>
                                      <option v-for="option in field.options" :key="option" :value="option">{{ formatSectionName(option) }}</option>
                                    </select>

                                    <multiselect
                                        v-if="field.type === 'multipleDropDown'"
                                        v-model="formData[section][index]['value']"
                                        :options="field.options"
                                        :multiple="true"
                                        class="shorten-multiselect-option"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :placeholder="'Select ' + field.title"
                                        :name="field.name"
                                    ></multiselect>


                                    <!-- Checkbox Input -->
                                    <div class="custom-control custom-switch mb-1" v-if="field.type === 'checkbox'">
                                      <input
                                          type="checkbox"
                                          class="custom-control-input"
                                          :id="field.name"
                                          v-model="fields[index].value"
                                      />
                                      <label class="custom-control-label" :for="field.name">{{ field.title }}</label>
                                    </div>

                                    <small v-show="errorBag.has(field.name)" class="invalid-feedback">
                                      {{ "*" + errorBag.first(field.name) }}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="modal-footer justify-content-center">
                  <button
                      type="button"
                      class="btn btn-primary mr-1 d-flex"
                      @click="sendCall"
                      :disabled="loading || disableSave"
                  >
                    <Loader :loading="loading" :size="size"></Loader>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <CustomConfirmationModal :show="showClearAllConfirmationModal || showClearDefaultConfirmationModal" @confirm="confirmClear" :message="showClearDefaultConfirmationModal? 'Are you sure to clear default configurations only?':'Are you sure to clear all configurations?'"
                             title="Please Confirm"
                             @hide="showClearAllConfirmationModal = false; showClearDefaultConfirmationModal = false; clearSettlementConfigurations = false"></CustomConfirmationModal>
    <VerifyIbanModal
        :show="showIbanModal"
        :iban="ibanField?.value"
        :response="ibanResponse"
        :loading="ibanLoading"
        :error="ibanError"
        @close="showIbanModal = false"
        @verify="handleVerifyIban"
        @save="handleSaveIban"
        @clear-error="ibanError = null"
    />


    <IbanDetailsModal
        :show="showIbanDetailsModal"
        :data="ibanDetailsResponse"
        @close="showIbanDetailsModal = false"
        :loading="ibanLoading"
        @save="handleSaveIban"
    />


  </div>
  <!-- END: Content-->
</template>

<script>
import CustomConfirmationModal from "@/pages/dashboard/schema/customConfirmationModal.vue";
import VerifyIbanModal from "@/pages/dashboard/merchant/channels/VerifyIbanModal.vue";
import IbanDetailsModal from "@/pages/dashboard/merchant/channels/IbanDetailsModal.vue";

export default {
  components: {
    IbanDetailsModal,
    VerifyIbanModal,
    CustomConfirmationModal

  },
  mounted() {
    this.setBreadCrumb()
    this.getConfigurationSettings()
  },
  computed: {
    settlementFields() {
      return this.formData.settlementConfigurations || []
    },

    ibanField() {
      return this.settlementFields.find(f => f.name === 'iban')
    },
  },
  data() {
    return {
      currentBreadCrumb:[],
      name: "",
      type: null,
      settingsList: [],
      formData: {},
      mergedFields: [],
      loading: false,
      size: "10px",
      terminalId:'',
      channelId:'',
      id: "",
      index: "",
      showClearAllConfirmationModal:false,
      showClearDefaultConfirmationModal:false,
      defaultData:null,
      disableSave:false,
      clearSettlementConfigurations:false,
      showIbanModal: false,
      ibanResponse: null,
      ibanLoading: false,
      ibanVerified: false,
      ibanDetailsLoading: false,
      ibanDetails: null,
      showIbanDetailsModal: false,
      ibanDetailsResponse: null,
      ibanStatus:null,
      ibanError: null,
      updateAccountTitleLoading: false

    };
  },

  methods: {
    setBreadCrumb(){
      var merchantChannel = this.$store.getters.getByKey(
          "merchantChannel"
      );

      this.currentBreadCrumb.push(merchantChannel.row.name+'/'+merchantChannel.row.code)

      const channelData = this.$store.getters.getByKey("configurationSettings");

      if(channelData.row?.name){
        this.currentBreadCrumb.push('Channel')
        this.currentBreadCrumb.push(channelData.row.name+'/'+channelData.row.code)
      }
    },
    clearAll(section){
      if(section === 'settlementConfigurations'){
        this.clearSettlementConfigurations = true
      }
      this.showClearAllConfirmationModal = true
    },
    confirmClear(){
      if(this.clearSettlementConfigurations){
        this.clearAllConfigParameters('settlementConfigurations')
        this.clearSettlementConfigurations = false
        return
      }
      if(this.showClearDefaultConfirmationModal){
        this.clearDefaultConfigurationParameters()
      }else{
        this.clearAllConfigParameters('terminalConfigurationParameters')
      }
    },
    clearDefaultConfigurationParameters() {
      if (!this.defaultData || !this.defaultData.terminalConfigurationParameters) {
        return;
      }

      const defaultFields = this.defaultData.terminalConfigurationParameters;

      // Create a quick lookup by name
      const defaultFieldsMap = {};
      defaultFields.forEach(field => {
        defaultFieldsMap[field.name] = field;
      });

      if (this.formData.terminalConfigurationParameters) {
        this.formData.terminalConfigurationParameters = this.formData.terminalConfigurationParameters.map(field => {
          const defaultField = defaultFieldsMap[field.name];

          if (defaultField) {
            // If the current value matches the default value
            if (field.value === defaultField.value) {
              return {
                ...field,
                value: field.type === 'checkbox' ? false : ''
              };
            }
          }

          return field; // Otherwise leave it unchanged
        });

        this.formData = { ...this.formData };
        this.showClearAllConfirmationModal = false
        this.showClearDefaultConfirmationModal = false
      }
    },
    clearAllConfigParameters(sectionName = 'terminalConfigurationParameters') {
      Object.keys(this.formData).forEach(section => {
        if(section == sectionName){
          this.formData[section] = this.formData[section].map(field => ({
            ...field,
            value: field.type === 'checkbox' ? false : ''
          }));
        }
      })

      this.formData = {...this.formData}
      this.showClearAllConfirmationModal = false
      this.showClearDefaultConfirmationModal = false

      if(sectionName == 'settlementConfigurations'){
        this.onIbanInput()
      }
    },
    getConfigurationSettings(){
      this.loader = true
      this.makeRequest("post", "v1/get-charges-types-data", {channelSettings: 1}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {

                let data = callResponse.response.data.data;
                this.defaultData = JSON.parse(data.channelSettings)
                this.processResponseData(JSON.parse(data.channelSettings));
              }
            }
          }
      );
    },
    processResponseData(data) {
      this.formData = {};

      const channelData = this.$store.getters.getByKey("configurationSettings");

      Object.keys(data).forEach(section => {
        if(channelData.row?.type.toString() != 2){
          // then show only settlementConfigurations
          if(section != 'settlementConfigurations'){
            return
          }

        }
        this.$set(this.formData, section, []);
        this.formData[section] = data[section].map(field => ({
          ...field,
          value: field.type === 'checkbox' ? false :
                    field.type === 'multipleDropDown' ? (field.value || []) :
                        field.value || ''
        }));

        if(channelData.row?.type.toString() != 2 && !data['settlementConfigurations']?.length ){
          this.disableSave = true
        }




        // Check if there is corresponding data in the settings
        if (channelData?.row) {

          const settings = channelData.row?.settings;

          // If the section exists in the settings, populate the form data
          if (settings && settings[section]) {
            this.formData[section].forEach(field => {
              // If the field has a matching value in the settings, update it
              if (settings[section][field.name] !== undefined) {
                field.value = settings[section][field.name];
                if(field.name == 'iban' && field.value != ''){
                  this.ibanVerified = true
                }
              }
            });
          }
        }
      });


    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;


          let rawData = {};

          Object.keys(this.formData).forEach(section => {
            this.formData[section].forEach(field => {
              if(field.type === 'checkbox'){
                if(field.value != true){
                  return
                }
              }

              if(field.value == '' || field.value == null){
                return;
              }

              rawData[field.name] = field.value;

            });
          });

          let data = {
            channelId: this.$route.params.channelId,
            settings: JSON.stringify(rawData)
          }

          this.makeRequest("post", "v1/update-channel-settings", data).then(
              callResponse => {
                this.loading = false
                if (!callResponse.error) {
                  const channelData = this.$store.getters.getByKey("configurationSettings");
                  let storeRefreshedData = {
                    ...channelData,
                    row:{
                      ...channelData.row,
                      settings:callResponse.response?.data?.data?.settings ?? channelData.row.settings
                    }
                  };
                  this.$store.dispatch("set", storeRefreshedData);
                }
              }

          );

        }
      });
    },
    formatSectionName(name) {
      return name
          .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
          .replace(/_/g, " ") // Replace underscores with spaces
          .replace(/\b\w/g, c => c.toUpperCase()) // Capitalize first letter of each word
          .trim(); // Remove leading/trailing spaces
    },
    openIbanVerifyModal() {
      this.showIbanModal = true
      this.ibanResponse = null
      this.saveWithCustomAccountTitle = false
    },
    handleVerifyIban(payload) {
      this.ibanLoading = true;
      this.ibanError = null

      this.makeRequest("post", "v1/verify-iban", {
        channelId: this.$route.params.channelId,
        iban: payload.iban,
        // saveWithCustomAccountTitle: payload.saveWithCustomAccountTitle ? 1 : 0
      }).then(res => {
        this.ibanLoading = false;
        let code = res.response.data.code;
        if (!res.error && code == 200) {
          this.ibanResponse = res.response.data.data;
          this.ibanVerified = true;
          this.ibanStatus = this.ibanResponse.status;
        }else{
          if (code == 400) {
            this.ibanError =
                res.response?.data?.message ||
                "Unable to verify IBAN. Please try again."
          }
          this.ibanVerified = false;
          this.ibanStatus = null;
        }
      });
    },

    handleSaveIban(payload) {
      this.ibanLoading = true;

      const requestData = {
        channelId: this.$route.params.channelId,
        iban: payload.iban,
        // saveWithCustomAccountTitle: payload.saveWithCustomAccountTitle ? 1 : 0,
        save: payload.save ?? 1
      };

      if (payload.accountTitle) {
        requestData.accountTitle = payload.accountTitle;
      }

      this.makeRequest("post", "v1/verify-iban", requestData).then(res => {
        this.ibanLoading = false;
        let code = res.response.data.code;
        if (!res.error && code == 200) {
          this.ibanResponse = res.response.data.data;
          this.showIbanModal = false;
          this.showIbanDetailsModal = false;
          this.ibanVerified = true;
          this.ibanStatus = 1;

          if(payload.fromDetails){
            this.ibanDetailsResponse = {...this.ibanDetailsResponse, status: 1};
          }

          this.openSettlementSettings()
        }
      });
    },
    onIbanInput() {
      // Remove spaces from IBAN value
      if (this.ibanField) {
        this.ibanField.value = this.ibanField.value.replace(/\s/g, '');
      }
      this.ibanVerified = false
      this.ibanResponse = null
      this.ibanDetailsResponse = null
      this.ibanStatus = null;
    },
    onIbanKeydown(event) {
      // Prevent space key
      if (event.key === ' ') {
        event.preventDefault();
      }
    },
    openSettlementSettings() {
      if (!this.ibanField?.value) {
        return
      }

      this.ibanLoading = true
      this.ibanDetailsResponse = null

      this.makeRequest("post", "v1/get-iban-details", {
        channelId: this.$route.params.channelId,
        iban: this.ibanField.value
      }, {}, false).then(res => {
        this.ibanLoading = false

        if (res.error) return

        const data = res.response.data.data

        if (!data) {
          this.ibanVerified = false;
          this.ibanStatus = null;
          return
        }

        this.ibanDetailsResponse = data
        this.ibanStatus = data.status;
      })
    },
  }
};
</script>

